// Components==============
import Button from 'components/UI/Button';
import Checkbox from 'components/UI/Checkbox';
import { TextInput } from 'components/UI/Form/Input';
import Modal from 'components/UI/Modal';
import React, { useState } from 'react';
import { useFormValues } from 'utilities/useFormValues';
import { useDispatch } from 'react-redux';
import sendEmail from 'actions/mail/send';
import './index.module.scss';
import { useCloseUrlModal } from 'utilities/useCloseUrlModal';
// =========================

export default function NewsModal() {
    const [displayMessage, setDisplayMessage] = useState('');
    const [mailConfirm, setMailConfirm] = useState('');

    const { formValues, handleChange } = useFormValues(
        {
            name: '',
            mail: '',
        },
        () => setDisplayMessage('')
    );

    const closeUrlModal = useCloseUrlModal();

    const [hasAgreed, setHasAgreed] = useState(false);
    const dispatch = useDispatch();

    const { name, mail } = formValues;

    function handleSubmit(e) {
        e.preventDefault();
        if (!hasAgreed) return;

        if (mail !== mailConfirm) return;

        dispatch(
            sendEmail({
                ...formValues,
                type: 'nieuwsbrief',
            })
        ).then((r) => {
            closeUrlModal();
        });
    }

    return (
        <Modal slug="nieuwsbrief-popup">
            <div styleName="content">
                <h2>Nieuwsbrief</h2>
                <p styleName="text">
                    Schrijf je hier in voor onze nieuwsbrief!
                </p>
                <form onSubmit={handleSubmit}>
                    <TextInput
                        label="Naam *"
                        name="name"
                        value={name}
                        onChange={handleChange}
                    />
                    <TextInput
                        label="E-mailadres *"
                        name="mail"
                        type="email"
                        value={mail}
                        onChange={handleChange}
                    />
                    <TextInput
                        label="E-mailadres bevestiging *"
                        name="mailConfirm"
                        type="email"
                        value={mailConfirm}
                        onChange={(e) => {
                            setDisplayMessage('');
                            setMailConfirm(e.target.value);
                        }}
                    />
                    <div
                        onClick={() => setHasAgreed((prev) => !prev)}
                        styleName="agreeBox"
                    >
                        <Checkbox isSelected={hasAgreed} />
                        <p>
                            Ik ga akkoord met het beheer en de verwerking van
                            mijn gegevens. Ontwikkelplatform NXT werkt conform
                            de AVG wet- en regelgeving.
                        </p>
                    </div>
                    <Button>Aanmelden nieuwsbrief</Button>
                </form>
                {displayMessage && <p styleName="error">{displayMessage}</p>}
            </div>
        </Modal>
    );
}
